import { useState } from "react";
import { blog } from "../../data/blogs";
import BlogPost from "../BlogPost";
import CommentList from "../CommentList";
import CommentForm from "../CommentForm";
import Header from "./Header";

const commentsData = [
  {
    id: "kskBC5HZ8qgNQUiW6If6q",
    author: "Billy Bootcamper",
    content: "Hello, great post",
  },
  {
    id: "jFyGAKz1VsGputO1gV8xa",
    author: "Chris Meah",
    content: "Many thank yous",
  },
];

function App() {
  let [comment, setComment] = useState(commentsData);
  function commentHandler(inputData) {
    comment.push(inputData);
    setComment([...comment]);
  }
  let [light, setLight] = useState(true);
  function lightSwitch() {
    light
      ? document.body.classList.add("darkMode")
      : document.body.classList.remove("darkMode");
    setLight(!light);
  }
  return (
    <>
      <Header light={light} lightSwitch={lightSwitch} />
      <BlogPost blog={blog} light={light} />
      <CommentList comments={comment} light={light} />
      <CommentForm addComment={commentHandler} light={light} />
    </>
  );
}

export default App;
